<template>
  <BaseCustomizeMetal componentCode="AM">
    <template slot="respect" slot-scope="{ text }">
      <div class="text">
        <span v-html="text.split('')[0] || ''"></span>
        <span v-html="text.split('')[1] || ''"></span>
      </div>
    </template>
  </BaseCustomizeMetal>
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAM",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 100px;
    left: 133px;
    @include betweenTableTablePro {
      top: 61px;
      left: 86px;
    }
    @include table {
      top: 47px;
      left: 60px;
    }
    @include phone {
      top: 34px;
      left: 45px;
    }
  }
  .templeName {
    height: 28px;
    width: 165px;
    .textContainer {
      width: 165px;
    }
  }
  .godName {
    width: 226px;
    height: 72px;
    .textContainer {
      width: 226px;
    }
  }
  .gift {
    width: 230px;
    height: 32px;
    .textContainer {
      width: 230px;
    }
  }
  .respect {
    width: 46px;
    margin: 6px auto;
    .text {
      position: relative;
      span {
        position: absolute;
      }
      span:nth-child(1) {
        left: -15px;
      }
      span:nth-child(2) {
        right: -20px;
      }
    }
  }
}
</style>
